export const state = {
  milestones: [],
  isLoading: false,
  totalRecords: 0,
  milestonePerPage: 10000,
  activePage: 1
}
